module.exports = __webpack_public_path__ + "static/media/10x201.803ba475.png";